import { State } from "@progress/kendo-data-query";

export enum ExportDataServiceNames {
    FormTemplateInstancesService = 'FormTemplateInstancesService'
}

export class GenericExportDataAsExcelSpreadsheet {
    public formFieldId: number;
    public formInstanceElementId: number;
    // PJH - added for VNEXT-1380
    public formInstanceIds: number[];
    // PJH - added for VNEXT-1380
    public allFormsSelected: boolean;

    public serviceName: string;

    public gridState: State;

    public constructor(formFieldId: number, serviceName: string, formIds: number[], allFormsSelected: boolean) {
        this.formFieldId = formFieldId;
        this.serviceName = serviceName;
        this.formInstanceIds = formIds;
        this.allFormsSelected = allFormsSelected;
    }
}
